module.exports = new __parcel__URL__("list-embed-app-skeleton.tpl.de94c811.svg").toString();